;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="10613068-ef63-43d2-91bf-b346b2c37671",e._sentryDebugIdIdentifier="sentry-dbid-10613068-ef63-43d2-91bf-b346b2c37671")}catch(e){}}();
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(35970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_redux_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34705);
/* harmony import */ var src_redux_slice_User_User__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85195);
/* harmony import */ var src_redux_types_User_urser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7847);







var withAuthorization = function(allowedRoles) {
    return function(WrappedComponent) {
        var Wrapper = function(props) {
            var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
            var userType = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_3__/* .useAppSelector */ .C)(src_redux_slice_User_User__WEBPACK_IMPORTED_MODULE_4__/* .userReducer */ .M3).user.type;
            (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
                if (!userType) return;
                if (router.pathname === "/") {
                    if (userType === src_redux_types_User_urser__WEBPACK_IMPORTED_MODULE_5__/* .UserType.TEACHER */ .F.TEACHER) router.push("/teachers");
                    else if (userType === src_redux_types_User_urser__WEBPACK_IMPORTED_MODULE_5__/* .UserType.STUDENT */ .F.STUDENT) router.push("/courses");
                } else if (!allowedRoles.includes(userType)) {
                    router.replace("/404");
                }
            }, [
                router.pathname,
                userType
            ]);
            if (!userType || !allowedRoles.includes(userType)) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
        };
        Wrapper.displayName = "WithAuthorization(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")");
        return Wrapper;
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withAuthorization);


/***/ }),

/***/ 35970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var src_HOC_withAuthorization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94192);
/* harmony import */ var src_redux_types_User_urser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7847);



var IndexPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["default"] = ((0,src_HOC_withAuthorization__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
    src_redux_types_User_urser__WEBPACK_IMPORTED_MODULE_2__/* .UserType.TEACHER */ .F.TEACHER,
    src_redux_types_User_urser__WEBPACK_IMPORTED_MODULE_2__/* .UserType.STUDENT */ .F.STUDENT
])(IndexPage));


/***/ }),

/***/ 7847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ UserType; }
/* harmony export */ });
/* unused harmony export IUserStatus */
var UserType;
(function(UserType) {
    UserType["STUDENT"] = "STUDENT";
    UserType["TEACHER"] = "TEACHER";
})(UserType || (UserType = {}));
var IUserStatus;
(function(IUserStatus) {
    IUserStatus["ACTIVE"] = "ACTIVE";
})(IUserStatus || (IUserStatus = {}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);